[
    {
        "id": 21,
        "result_type": "error",
        "ignored_reviewed": false,
        "clarity_accessibility_check_id": 1,
        "page_id": 5,
        "page_number": 0,
        "element_tree_path": "Tags->0->0->3",
        "reason": "A tag of type Figure does not define the Alt or Actual Text attributes.",
        "clarity_comments": "",
        "comments": [],
        "created_at": "2018-11-22T15:20:36+01:00",
        "updated_at": "2018-11-22T15:20:36+01:00",
        "latest_check_at": "2018-11-22T15:20:36+01:00"
    },
    {
        "id": 22,
        "result_type": "error",
        "ignored_reviewed": false,
        "clarity_accessibility_check_id": 1,
        "page_id": 5,
        "page_number": 0,
        "element_tree_path": "Tags->0->0->15",
        "reason": "A tag of type Figure does not define the Alt or Actual Text attributes.",
        "clarity_comments": "",
        "comments": [],
        "created_at": "2018-11-22T15:20:36+01:00",
        "updated_at": "2018-11-22T15:20:36+01:00",
        "latest_check_at": "2018-11-22T15:20:36+01:00"
    },
    {
        "id": 23,
        "result_type": "error",
        "ignored_reviewed": false,
        "clarity_accessibility_check_id": 1,
        "page_id": 5,
        "page_number": 0,
        "element_tree_path": "Tags->0->0->21",
        "reason": "A tag of type Figure does not define the Alt or Actual Text attributes.",
        "clarity_comments": "",
        "comments": [],
        "created_at": "2018-11-22T15:20:36+01:00",
        "updated_at": "2018-11-22T15:20:36+01:00",
        "latest_check_at": "2018-11-22T15:20:36+01:00"
    },
    {
        "id": 24,
        "result_type": "error",
        "ignored_reviewed": false,
        "clarity_accessibility_check_id": 1,
        "page_id": 5,
        "page_number": 0,
        "element_tree_path": "Tags->0->0->23",
        "reason": "A tag of type Figure does not define the Alt or Actual Text attributes.",
        "clarity_comments": "",
        "comments": [],
        "created_at": "2018-11-22T15:20:36+01:00",
        "updated_at": "2018-11-22T15:20:36+01:00",
        "latest_check_at": "2018-11-22T15:20:36+01:00"
    },
    {
        "id": 25,
        "result_type": "error",
        "ignored_reviewed": false,
        "clarity_accessibility_check_id": 1,
        "page_id": 5,
        "page_number": 1,
        "element_tree_path": "Tags->0->0->26",
        "reason": "A tag of type Figure does not define the Alt or Actual Text attributes.",
        "clarity_comments": "",
        "comments": [],
        "created_at": "2018-11-22T15:20:36+01:00",
        "updated_at": "2018-11-22T15:20:36+01:00",
        "latest_check_at": "2018-11-22T15:20:36+01:00"
    },
    {
        "id": 26,
        "result_type": "error",
        "ignored_reviewed": false,
        "clarity_accessibility_check_id": 1,
        "page_id": 5,
        "page_number": 1,
        "element_tree_path": "Tags->0->0->40",
        "reason": "A tag of type Figure does not define the Alt or Actual Text attributes.",
        "clarity_comments": "",
        "comments": [],
        "created_at": "2018-11-22T15:20:36+01:00",
        "updated_at": "2018-11-22T15:20:36+01:00",
        "latest_check_at": "2018-11-22T15:20:36+01:00"
    },
    {
        "id": 27,
        "result_type": "error",
        "ignored_reviewed": false,
        "clarity_accessibility_check_id": 1,
        "page_id": 5,
        "page_number": 1,
        "element_tree_path": "Tags->0->0->54",
        "reason": "A tag of type Figure does not define the Alt or Actual Text attributes.",
        "clarity_comments": "",
        "comments": [],
        "created_at": "2018-11-22T15:20:36+01:00",
        "updated_at": "2018-11-22T15:20:36+01:00",
        "latest_check_at": "2018-11-22T15:20:36+01:00"
    },
    {
        "id": 28,
        "result_type": "error",
        "ignored_reviewed": false,
        "clarity_accessibility_check_id": 1,
        "page_id": 5,
        "page_number": 1,
        "element_tree_path": "Tags->0->0->68",
        "reason": "A tag of type Figure does not define the Alt or Actual Text attributes.",
        "clarity_comments": "",
        "comments": [],
        "created_at": "2018-11-22T15:20:36+01:00",
        "updated_at": "2018-11-22T15:20:36+01:00",
        "latest_check_at": "2018-11-22T15:20:36+01:00"
    },
    {
        "id": 29,
        "result_type": "error",
        "ignored_reviewed": false,
        "clarity_accessibility_check_id": 1,
        "page_id": 5,
        "page_number": 1,
        "element_tree_path": "Tags->0->0->80",
        "reason": "A tag of type Figure does not define the Alt or Actual Text attributes.",
        "clarity_comments": "",
        "comments": [],
        "created_at": "2018-11-22T15:20:36+01:00",
        "updated_at": "2018-11-22T15:20:36+01:00",
        "latest_check_at": "2018-11-22T15:20:36+01:00"
    }
]
